export const DESCRIPTIONS = {
  sizeGreaterThen: (name: string, size: number) =>
    $localize`:@@TOASTS_SIZE_EXCEEDS_LIMIT:'${name}' exceeds the ${size}MB size limit.`,
  notSupportedExtension: (name: string) =>
    $localize`:@@TOASTS_UNSUPPORTED_EXTENSION:This extension of '${name}' is not supported`,
  storageLimitExceeded: (name: string) =>
    $localize`:@@DOCUMENTS_UPLOAD_SPACE_LIMIT:‘${name}’ exceeds the available storage space.`,
  photoReachedLimit: $localize`:@@TOASTS_PHOTO_LIMIT:You have reached the maximum photo limit`,
  docReachedLimit: $localize`:@@TOASTS_DOC_LIMIT:You have reached the maximum document limit`,
  videoReachedLimit: $localize`:@@TOASTS_VIDEO_LIMIT:You have reached the maximum video link limit`,
  photoExceededLimit: $localize`:@@TOASTS_PHOTO_LIMIT_EXCEEDED:You have exceeded the maximum photo limit`,
  docExceededLimit: $localize`:@@TOASTS_DOC_LIMIT_EXCEEDED:You have exceeded the maximum document limit`,
  videoExceededLimit: $localize`:@@TOASTS_VIDEO_LIMIT_EXCEEDED:You have exceeded the maximum video link limit`,
  uploadNoManagePermission: $localize`:@@UPLOAD_DISABLED_NO_DOCUMENTS_PERMISSION:File uploads disabled. No permissions to manage the document panel.`,
  addFromDocumentsNoViewPermission: $localize`:@@ADD_FROM_DOCUMENTS_DISABLED_NO_VIEW_PERMISSION:Adding from documents disabled. No permissions to view the document panel.`
};
